/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
import React, { Component } from 'react';
import { injectIntl, FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { personalInformation } from 'shared/store/actions';
import {
  PaddedContainer,
  Input,
  FormElementContainer,
  Label,
  ButtonPlus,
  Options,
  Notes,
  SelectBox,
  Heading,
} from 'components';
import selectors from 'shared/store/selectors';
import {
  FORM_KEYS,
  CLIENT_CLASSIFICATION,
  TYPE_OF_INVESTMENT,
  QUALIFIED_TYPE_OF_INVESTMENT,
} from 'shared/constant';
import arrOptions from 'shared/constant/arrOptions';
import validation from 'shared/validations';
import utils from 'shared/helpers/utils';

class Pep extends Component {
  onElementChange = (e) => {
    const { id } = e.target;
    const { getStringAfterSpecialChar } = utils;
    const selected = getStringAfterSpecialChar(id, '_');
    this.props.onUpdateIsPep(selected);

    if (id === 'isPep_yes' && this.props.arrOfPep.length <= 0) {
      this.props.onAddMorePep();
    }
  };

  onPepChange = (index, { target }) => {
    this.props.onUpdatePep(index, target.name, target.value);
  };

  handleRemovePep = (id) => {
    this.props.onRemovePep(id);
  };

  onInsiderChange = (index, { target }) => {
    this.props.onUpdateInsider(index, target.name, target.value);
  };

  handleRemoveInsider = (id) => {
    this.props.onRemoveInsider(id);
  };

  onInsiderElementChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;
    this.props.onUpdateClientProfile(fieldName, fieldValue);
    // console.log(e);
  };

  render() {
    const {
      intl,
      isPep,
      arrOfPep,
      onAddMorePep,
      onUpdatePep,
      isSubmitClicked,
      insiderStatus,
      insiderList,
      onAddMoreInsider,
      clientClassification,
      typeOfInvestment,
      restrictions,
      formOptions: { pepPosition },
    } = this.props;
    const { PEP, CLIENT_PROFILE_FORM } = FORM_KEYS;
    const { defaultBoolOptions, positionOptions } = arrOptions;
    const isDiscretionary = !!(
      clientClassification === CLIENT_CLASSIFICATION.QUALIFIED
      && typeOfInvestment === QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY
    );

    const elementValidation = {
      [PEP.IS_PEP]: {
        isValid: validation
          .pepFieldsSchema(intl, PEP.IS_PEP)
          .isValidSync({ isPep }),
        errorMessage: validation.getErrorMessages(
          { isPep },
          validation.pepFieldsSchema(intl, PEP.IS_PEP),
        ),
      },
      [CLIENT_PROFILE_FORM.INSIDER_STATUS]: {
        isValid: validation
          .pepFieldsSchema(
            intl,
            CLIENT_PROFILE_FORM.INSIDER_STATUS,
            isDiscretionary,
            restrictions,
            clientClassification,
            typeOfInvestment,
          )
          .isValidSync({ insiderStatus }),
        errorMessage: validation.getErrorMessages(
          { insiderStatus },
          validation.pepFieldsSchema(
            intl,
            CLIENT_PROFILE_FORM.INSIDER_STATUS,
            isDiscretionary,
            restrictions,
            clientClassification,
            typeOfInvestment,
          ),
        ),
      },
      // [PEP.BENEFICIARIES]: {
      //   isValid: validation.pepListSchema(intl, PEP.IS_PEP).isValidSync({ list: arrOfPep }),
      //   errorMessage: validation.getErrorMessages({ list: arrOfPep }, validation.pepListSchema(intl, PEP.IS_PEP)),
      // },
    };

    const isPepListValid = validation.pepListSchema(intl, isPep).isValidSync({
      list: arrOfPep,
    });

    /** Required PEP fields listed in the error message; other position only when selected */
    const isOtherPositionRequired = !!arrOfPep && arrOfPep.some(item => item[PEP.POSITION] === 'NW-MAR-PEP-OT');
    const pepListRequiredFields = [
      'validation.pepList.name',
      'validation.pepList.position',
      ...(isOtherPositionRequired ? ['validation.pepList.otherPosition'] : []),
      'validation.pepList.relationship',
    ].map(id => intl.formatMessage({ id }));
    const pepListErrorMessage = intl.formatMessage({ id: 'validation.pepList' }, {
      fields: pepListRequiredFields.slice(0, -1).join(intl.formatMessage({ id: 'validation.pepList.separator' })),
      lastField: pepListRequiredFields[pepListRequiredFields.length - 1],
    });

    const { translateAnswer } = utils;

    // const pepListErrorMessage = validation.getErrorMessages({
    //   list: arrOfPep,
    // }, validation.pepListSchema(intl, isPep));

    const isInsiderListValid = validation
      .insiderListSchema(intl, insiderStatus)
      .isValidSync({ insiderStatusList: insiderList });

    return (
      <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
        <FormElementContainer>
          <Label label={<FormattedHTMLMessage id="pep.question" />} />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            useLabel
            name={PEP.IS_PEP}
            optionList={defaultBoolOptions.map(item => ({
              id: `isPep_${item.id}`,
              label: item.label,
            }))}
            onCheckMarkChange={this.onElementChange}
            defaultValue={translateAnswer(isPep, intl)}
            isValid={elementValidation[PEP.IS_PEP].isValid}
            errorMessage={elementValidation[PEP.IS_PEP].errorMessage}
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        <Notes
          msg={(
            <div>
              <p>
                <strong>{intl.formatMessage({ id: "info.pep.title" })}</strong>
                <br />
                <FormattedHTMLMessage id="info.pep.desc" />
              </p>
            </div>
          )}
        />

        {(translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' })
          || isPep === 'isPep_yes') && (
          <>
            <p>{intl.formatMessage({ id: 'pep.yes.complete' })}</p>

            {arrOfPep
              && arrOfPep.map((form, idx) => (
                <FormElementContainer
                  key={form.id}
                  id={form.id}
                  isWithPadding
                  isLightBg
                  isWithClose={idx > 0}
                  onClose={() => this.handleRemovePep(form.id)}
                >
                  <Input
                    label={intl.formatMessage({ id: 'pep.name' })}
                    // placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'pep.name' })}`}
                    placeholder={`${intl.formatMessage({ id: 'pep.name.placeholder' })}`}
                    id={`${form.name}-${idx}`}
                    name={PEP.NAME}
                    onInputChange={e => this.onPepChange(idx, e)}
                    value={form[PEP.NAME]}
                    isSubmitClicked={isSubmitClicked}
                    // isValid={isPepListValid}
                    // errorMessage={pepListErrorMessage}
                  />

                  <FormElementContainer>
                    <Label label={<FormattedHTMLMessage id="pep.position" />} />
                    <Options
                      isMultpleElements
                      type="radio"
                      hasContainer
                      useLabel
                      name={`${PEP.CURRENT_FORMER_OPTION}-${idx}`}
                      optionList={positionOptions.map(item => ({
                        id: `isCurrent-${idx}_${item.id}`,
                        label: item.label.toLowerCase(),
                      }))}
                      onCheckMarkChange={(e) => {
                        const { getStringAfterSpecialChar } = utils;
                        const selected = getStringAfterSpecialChar(
                          e.target.id,
                          '_',
                        );
                        onUpdatePep(idx, PEP.CURRENT_FORMER_OPTION, selected);
                      }}
                      // optionList={positionOptions.map(item => ({ id: `isCurrent-${item.id}-${idx}`, label: item.label }))}
                      // onCheckMarkChange={e => onUpdatePep(idx, PEP.CURRENT_FORMER_OPTION, e.target.value)}
                      defaultValue={translateAnswer(
                        form[PEP.CURRENT_FORMER_OPTION],
                        intl,
                      )}
                      isSubmitClicked={isSubmitClicked}
                    />
                  </FormElementContainer>

                  <SelectBox
                    label={intl.formatMessage({
                      id: 'pep.currentFormerPosition',
                    })}
                    // placeholder={`${intl.formatMessage({ id: 'enter' })} ${form.currentFormerOption && intl.formatMessage({ id: form[PEP.CURRENT_FORMER_OPTION] }).toLowerCase()} ${intl.formatMessage({ id: 'pep.position' }).toLowerCase()}`}
                    placeholder={
                      form[PEP.CURRENT_FORMER_OPTION] === 'current'
                        ? `${intl.formatMessage({ id: 'pep.Currentposition.placeholder' })}`
                        : form[PEP.CURRENT_FORMER_OPTION] === 'former'
                          ? `${intl.formatMessage({ id: 'enter' })} ${form.currentFormerOption && intl.formatMessage({ id: form[PEP.CURRENT_FORMER_OPTION] }).toLowerCase()} ${intl.formatMessage({ id: 'pep.position' }).toLowerCase()}`
                          : `${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'pep.position' }).toLowerCase()}`
                    }
                    hasContainer
                    id={`${form.position}-${idx}`}
                    name={`${PEP.POSITION}-${idx}`}
                    dataList={pepPosition}
                    onSelect={(name, value) => this.props.onUpdatePep(idx, 'position', value)
                    }
                    defaultValue={form[PEP.POSITION]}
                    isSubmitClicked={isSubmitClicked}
                  />

                  {form[PEP.POSITION] === 'NW-MAR-PEP-OT' ? (
                    <Input
                      label={intl.formatMessage({ id: 'pep.other_position' })}
                      placeholder={intl.formatMessage({ id: 'pep.other_position.placeholder' })}
                      id={`${PEP.OTHER_POSITION}-${idx}`}
                      name={PEP.OTHER_POSITION}
                      onInputChange={e => this.onPepChange(idx, e)}
                      value={form[PEP.OTHER_POSITION]}
                      isSubmitClicked={isSubmitClicked}
                      maxLength={120}
                    />
                  ) : null}

                  <Input
                    label={intl.formatMessage({ id: 'pep.relationship' })}
                    placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'pep.relationship' }).toLowerCase()}`}
                    id={`${form.relationship}-${idx}`}
                    name={PEP.RELATIONSHIP}
                    onInputChange={e => this.onPepChange(idx, e)}
                    value={form[PEP.RELATIONSHIP]}
                    // isValid={isPepListValid(form.name, form.position, form.relationship)}
                    // errorMessage={pepListErrorMessage(form.name, form.position, form.relationship)}
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>
              ))}

            {!isPepListValid && isSubmitClicked && (
              <span
                className="notification notification--error"
                style={{ display: 'block', marginTop: '5px' }}
              >
                {pepListErrorMessage}
              </span>
            )}
            {/* {console.log(`is page valid: ${isPepListValid} - display error ${pepListErrorMessage}`)} */}

            <ButtonPlus
              onButtonClick={onAddMorePep}
              label={intl.formatMessage({ id: 'pep.addMore' })}
            />
          </>
        )}

        {/* INSIDER STATUS: HIDE IF CLASSIFIED AS RETAIL CLIENT WITH ONLY MARKAZ FUNDS */}
        {!(
          clientClassification === CLIENT_CLASSIFICATION.RETAIL
          && typeOfInvestment === TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO
        ) && (
          <>
            <hr />
            <FormElementContainer>
              <Heading
                title={intl.formatMessage({
                  id: 'clientProfileForm.insiderStatus',
                })}
              />
              <FormElementContainer>
                <Label
                  label={intl.formatMessage({
                    id: 'clientProfileForm.insiderStatus.question',
                  })}
                />

                <Options
                  isMultpleElements
                  type="radio"
                  hasContainer
                  name={CLIENT_PROFILE_FORM.INSIDER_STATUS}
                  optionList={defaultBoolOptions.map(item => ({
                    id: `insiderStatus-${item.id}`,
                    label: item.label,
                  }))}
                  onCheckMarkChange={this.onInsiderElementChange}
                  defaultValue={insiderStatus}
                  // isValid={elementValidation[CLIENT_PROFILE_FORM.INSIDER_STATUS].isValid}
                  // errorMessage={elementValidation[CLIENT_PROFILE_FORM.INSIDER_STATUS].errorMessage}
                  isSubmitClicked={isSubmitClicked}
                />
              </FormElementContainer>

              <Notes
                msg={(
                  <div>
                    <FormattedMessage id="info.investmentInsiderStatus" />
                  </div>
                )}
              />

              {insiderStatus === 'insiderStatus-yes' && (
                <FormElementContainer>
                  <p>
                    {intl.formatMessage({
                      id: 'insiderStatus.completeFollowing',
                    })}
                  </p>
                  {insiderList
                    && insiderList.map((form, idx) => (
                      <FormElementContainer
                        key={form.id}
                        id={form.id}
                        isWithPadding
                        isLightBg
                        isWithClose={idx > 0}
                        onClose={() => this.handleRemoveInsider(form.id)}
                      >
                        <Input
                          label={intl.formatMessage({
                            id: 'insiderStatus.company',
                          })}
                          placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'insiderStatus.company' })}`}
                          name={CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST_COMPANY}
                          id={`${form.insiderCompany}-${idx}`}
                          onInputChange={e => this.onInsiderChange(idx, e)}
                          value={form.insiderCompany}
                          // isValid={elementValidation[INSIDER_STATUS_LIST_COMPANY].isValid}
                          // errorMessage={elementValidation[INSIDER_STATUS_LIST_COMPANY].errorMessage}
                          // isSubmitClicked={isSubmitClicked}
                        />
                        <Input
                          label={intl.formatMessage({
                            id: 'insiderStatus.position',
                          })}
                          placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'insiderStatus.position' })}`}
                          name={
                            CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST_POSITION
                          }
                          id={`${form.insiderPosition}-${idx}`}
                          onInputChange={e => this.onInsiderChange(idx, e)}
                          value={form.insiderPosition}
                        />
                      </FormElementContainer>
                    ))}

                  {!isInsiderListValid && isSubmitClicked && (
                    <span
                      className="notification notification--error"
                      style={{ marginTop: '5px' }}
                    >
                      These are required fields
                    </span>
                  )}

                  <ButtonPlus
                    onButtonClick={onAddMoreInsider}
                    label={intl.formatMessage({ id: 'pep.addMore' })}
                  />
                </FormElementContainer>
              )}
            </FormElementContainer>
          </>
        )}
      </PaddedContainer>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: selectors.getLanguage(state),
  formOptions: selectors.getFormOptions(state),
  isPep: selectors.getisPep(state),
  arrOfPep: selectors.getPepList(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),

  restrictions: selectors.getCpfRestrictions(state),
  clientClassification: selectors.getClientClassification(state),
  typeOfInvestment: selectors.getTypeOfInvestment(state),
  insiderStatus: selectors.getCpfInsiderStatus(state),
  insiderList: selectors.getInsiderList(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateIsPep: value => dispatch(personalInformation.updateIsPep(value)),
  onAddMorePep: () => dispatch(personalInformation.addMorePep()),
  onUpdatePep: (index, key, value) => dispatch(personalInformation.updatePep(index, key, value)),
  onRemovePep: index => dispatch(personalInformation.removePep(index)),

  onAddMoreInsider: () => dispatch(personalInformation.addMoreInsider()),
  onUpdateInsider: (index, key, value) => dispatch(personalInformation.updateInsiderList(index, key, value)),
  onRemoveInsider: id => dispatch(personalInformation.removeInsiderItem(id)),
  onUpdateClientProfile: (name, value) => dispatch(personalInformation.updateClientProfile(name, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Pep));
